<template> 
	<el-affix class="fixed-top">
		<header :style="headerStyle" :class="{
			'scrolled': isScrolled
		}">
			<img alt="logo" 
				class="logo" 
				:src="isScrolled ? logo : logoWhite"
				height="60" />

			<div class="wrapper">
				<div class="">
					<a href="联系我们"></a>
				</div>
				<nav>
					<RouterLink to="/">首页</RouterLink>
					<a :href="nav.path || '/#'" v-for="(nav, index) in navList">{{nav.label}}</a>
				</nav>
			</div>
		</header> 
	</el-affix>
	<main>
		<RouterView />
	</main>
	<FooterView />
</template>

<script setup>
	import FooterView from '@/components/FooterView.vue'
	
	import { computed, onMounted } from 'vue'	
	import { RouterLink, RouterView } from 'vue-router'
	import logoWhite from '@/assets/logo_white.png'
	import logo from '@/assets/logo.png'

	const navList = ref([
		{ path: 'https://www.ylgg56.cn', label: '一歌TMS' },
		{ path: 'https://www.ylgg56.com.cn', label: '管车宝' },
		{ path: 'about', label: '关于我们' }
	])
	
	const isScrolled = ref(false)
	const scrollY = ref(0)
	
	const navOpacity = computed(() => {
	    return Math.min(scrollY.value / 200, 1);
	})
	
	const headerStyle = computed(() => {
		if(scrollY.value < 100) {
			return { 
				backgroundColor: `rgba(239, 99, 54, ${1-navOpacity.value})`
			}
		}
		return {
		    backgroundColor: `rgba(255, 255, 255, ${navOpacity.value})`,
		    boxShadow: navOpacity.value > 0.1 ? `0 2px 12px 0 rgba(0, 0, 0, ${navOpacity.value * 0.1})` : 'none'
		}; 
	})
	
	onMounted(() => {
		window.onscroll = (e) => {
			scrollY.value = window.scrollY 
			isScrolled.value = scrollY.value > 100
		}
	}) 
</script>

<style lang="scss" scoped>
	.fixed-top {
		background-color: #EF6336;
	}
	header {
		align-items: center; 
		background-color: #EF6336;
		display: flex;
		justify-content: space-between;
		line-height: 1.5; 
		padding: 1rem 2rem; 

		&.scrolled {
			
			a {
				color: #333;
				
				&:hover {
					color: #EF6336;
					text-decoration-color: #EF6336;
				}
			}
		}

		.logo {
			display: block;
			margin-left: .5rem;
		}

		nav {
			width: 100%;
			font-size: 21px;
			text-align: center;
			margin-top: 2rem;
			
			a { 
				color: #fff;
				padding: 0 1rem;
				
				&:hover {
					text-decoration: underline; 
					text-decoration-color: #fff; 
					text-decoration-thickness: 3px; 
					text-underline-offset: 23px;
				}
				
				&+a {
					margin-left: 1rem;
				}
			}
		}
	}
</style>